export default __webpack_public_path__ + "static/media/GPA-Commercial-Rebates.88c2a9d4.png";